import envs from "./envs";

export const getAuthTokenEndPoint = `${envs.hostApic}/oauth-end/oauth2/token`;
export const getLoginEndPoint = `${envs.hostApic}/public/oauth2/token`;
export const getResultadoAssembleia = ({ grupo, mes, ano }) =>
  `${envs.hostApic}/rs/v1.1/consorcios/assembleias/grupos/${grupo}/cotas?mes=${mes}&ano=${ano}`;
export const getResultadoSorteiosEndPoint = ({
  plano: { value: plano },
  dataBusca,
}) =>
  `${envs.hostApic}/rs/v2.0/capitalizacoes/sorteios/planos/${Number.parseInt(
    plano,
    10
  )}/resultados${dataBusca ? "?data=" : ""}${dataBusca || ""}`;

export const getSorteiosRealizadosEndPoint = ({ plano: { value: plano } }) =>
  `${envs.hostApic}/rs/v2.0/capitalizacoes/sorteios/planos/${Number.parseInt(
    plano,
    10
  )}/realizados`;
export const getJsonEndPoint = (jsonRelativePath) =>
  `${envs.hostStaticCdn}${jsonRelativePath}`;

export const getMapPremios = ({ ano, mes }) =>
  `${
    envs.hostApic
  }/rs/v2.0/capitalizacoes/sorteios/mapa/contemplacoes?numero-ano=${ano}${
    mes ? "&numero-mes=" : ""
  }${mes || ""}`;

export const getAcumuladoPremiometro = `${envs.hostApic}/rs/v2.0/capitalizacoes/sorteios/premios`;
